interface IBuildQuizUrlParams {
  quizId?: string;
  isFromBaseContent?: boolean;
  isTeacher?: boolean;
}

export const buildQuizUrl = ({ quizId, isFromBaseContent, isTeacher }: IBuildQuizUrlParams) => {
  const basePath = isTeacher ? '/content/tests' : '/evaluation/tests';
  const path = quizId ? `${basePath}/${quizId}/edit` : `${basePath}/create`;
  const params = new URLSearchParams();
  if (isFromBaseContent) params.set('isFromBaseContent', 'true');

  const query = params.toString();
  return query ? `${path}?${query}` : path;
};
